import React from "react";

import { ArchiveImagesNavMeta, NullArchiveImagesNavMeta } from "@/utilities/types/archive";


export const LiveUnitMetadataContext = React.createContext<ArchiveImagesNavMeta>(NullArchiveImagesNavMeta);
export const LiveUnitMetadataProvider = LiveUnitMetadataContext.Provider;
export const LiveUnitMetadataConsumer = LiveUnitMetadataContext.Consumer;

interface Props {
    metadata: ArchiveImagesNavMeta;
}

export const LiveUnitMetadataContextWrapper: React.FC<Props> = ({ metadata, children }) => {
    return <LiveUnitMetadataProvider value={metadata}>{children}</LiveUnitMetadataProvider>;
};
